module.exports = __webpack_public_path__ + "static/cortex-about-jm-min-34b981ae0a516f9f4d471d65e8eafaa3.png";